import { createFileRoute } from "@tanstack/react-router";
import { ExceptionsPage } from "../features/exceptions/pages/exceptions-page";

export const Route = createFileRoute("/exceptions")({
  component: ExceptionsRoute,
});

function ExceptionsRoute() {
  return <ExceptionsPage />;
}
